// Match the slug algorithm used by published MLP pages.
export function slugify(string: string) {
  return string
    .toLowerCase()
    .replaceAll(/[àáâãåā]/g, 'a')
    .replaceAll(/ä|æ/g, 'ae')
    .replaceAll(/[çćč]/g, 'c')
    .replaceAll(/[èéêëė]/g, 'e')
    .replaceAll(/[òóôõøō]/g, 'o')
    .replaceAll(/ö|œ/g, 'oe')
    .replaceAll(/š|ś/g, 's')
    .replaceAll('ß', 'ss')
    .replaceAll(/[ùúûū]/g, 'u')
    .replaceAll('ü', 'ue')
    .replaceAll(/ý|ÿ/g, 'y')
    .replaceAll('ž', 'z')
    .replaceAll(':', ' ')
    .replaceAll('.', ' ')
    .replaceAll(/[^\s\w-]/g, '')
    .replaceAll(/[\s_-]+/g, '-')
    .replaceAll(/^-+|-+$/g, '');
}
